import logo1 from "../../image/logotype/logo_corn.svg";
import logo2 from "../../image/logotype/MAS Seeds.svg";
import logo3 from "../../image/logotype/Agroseme-logo.jpg";
import logo4 from "../../image/logotype/480294581_468098586239588_3787685371877584840_n.jpg";
import logo5 from "../../image/logotype/logo-1.svg";
import goodsPage from "../../image/goods.image/corn/yyi2SKQwBy.png";
import goodsPage1 from "../../image/goods.image/corn/wjwx5vF0xB.jpeg";
import goodsPage2 from "../../image/goods.image/corn/agrosemesumo.jpg";
import goodsPage3 from "../../image/goods.image/corn/agrosemesumo2.jpg";
import goodsPage4 from "../../image/goods.image/corn/agrolider.jpg";
import goodsPage5 from "../../image/goods.image/corn/eurosem.jpg";
import Button from "../../assets/Button/ButtonBuy/ButtonBuy"
import { Link } from "react-router-dom";


export const items = [
  {
    title: "Насіння соняшнику AGROSEME СУПРЕМА",
    priceSecond: 'від 4 300 грн',
    priceThird: 'від 5 600 грн',
    priceFourth: 'від 6 000 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "AGROSEME",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage2} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "suprema",
    id: "7"
  },
  {
    title: "Насіння соняшнику AGROSEME НС Х 8005",
    priceSecond: 'від 4 100 грн',
    priceThird: 'від 5 600 грн',
    priceFourth: 'від 6 000 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "AGROSEME",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage2} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agroseme-НС-Х-8005",
    id: "8"
  },
  {
    title: "Насіння соняшнику AGROSEME ФЛЕШ",
    priceSecond: 'від 4 100 грн',
    priceThird: 'від 5 600 грн',
    priceFourth: 'від 6 000 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "AGROSEME",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage2} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agroseme-flash",
    id: "9"
  },
  {
    title: "Насіння соняшнику AGROSEME НС Х 7902",
    priceSecond: 'від 4 400 грн',
    priceThird: 'від 5 600 грн',
    priceFourth: 'від 6 000 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "AGROSEME",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage2} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agroseme-НС-Х-7902",
    id: "10"
  },
  {
    title: "Насіння соняшнику AGROSEME AЕРОН",
    priceSecond: 'від 4 300 грн',
    priceThird: 'від 5 600 грн',
    priceFourth: 'від 6 000 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "AGROSEME",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage3} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agroseme-aeron",
    id: "11"
  },
  {
    title: "Насіння соняшнику AGROSEME ГОЛІАТ",
    priceSecond: 'від 4 300 грн',
    priceThird: 'від 5 600 грн',
    priceFourth: 'від 6 000 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "AGROSEME",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage3} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agroseme-goliath",
    id: "12"
  },
  {
    title: "Насіння соняшнику AGROSEME НС-Х-6045",
    priceSecond: 'від 4 000 грн',
    priceThird: 'від 5 400 грн',
    priceFourth: 'від 5 800 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "AGROSEME",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage3} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agroseme-ns-x-6045",
    id: "13"
  },
  {
    title: "Насіння соняшнику AGROSEME ТАУРУС",
    priceSecond: 'від 3 900 грн',
    priceThird: 'від 5 200 грн',
    priceFourth: 'від 5 600 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "AGROSEME",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage3} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agroseme-taurus",
    id: "14"
  },
  {
    title: "Насіння соняшнику Агролідер НС Х 8005",
    priceSecond: 'від 1 175 грн',
    priceThird: 'від 3 262 грн',
    priceFourth: 'від 3 700 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "Агролідер",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo4} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage4} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agrolider-НС-Х-8005",
    id: "15"
  },
  {
    title: "Насіння соняшнику Агролідер Оскар",
    priceSecond: 'від 1 175 грн',
    priceThird: 'від 3 045 грн',
    priceFourth: 'від 3 400 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "Агролідер",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo4} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage4} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agrolider-oscar",
    id: "16"
  },
  {
    title: "Насіння соняшнику Агролідер НС Х 8002",
    priceSecond: 'від 1 100 грн',
    priceThird: 'від 2 350 грн',
    priceFourth: 'від 2 600 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "Агролідер",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo4} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage4} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agrolider-НС-Х-8002",
    id: "17"
  },
  {
    title: "Насіння соняшнику Агролідер НС Таурус",
    priceSecond: 'від 1 200 грн',
    priceThird: 'відсутні',
    priceFourth: 'від 3 300 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "Агролідер",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo4} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage4} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agrolider-taurus",
    id: "18"
  },
  {
    title: "Насіння соняшнику Агролідер НС Х 6045",
    priceSecond: 'від 1 100 грн',
    priceThird: 'від 3 000 грн',
    priceFourth: 'від 3 500 грн',
    unitSecond: "стандарт",
    unitThird: "екстра",
    unitFourth: "екстра+",
    producer: "Агролідер",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo4} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage4} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "agrolider-НС-Х-6045",
    id: "19"
  },
  {
    title: "Насіння соняшнику Євросем Фортем NS 7883",
    priceFirst: 'від 6 000 грн',
    priceSecond: 'від 4 200 грн',
    unitFirst: "преміум",
    unitSecond: "оптимум",
    producer: "Євросем",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo5} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage5} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "evrosem-NS-7883",
    id: "20"
  },
  {
    title: "Насіння соняшнику Євросем Пегас НС 6341",
    priceFirst: 'від 5 900 грн',
    priceSecond: 'від 4 100 грн',
    unitFirst: "преміум",
    unitSecond: "оптимум",
    producer: "Євросем",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo5} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage5} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "evrosem-NS-6341",
    id: "21"
  },
  {
    title: "Насіння соняшнику Євросем Грут НС 6343",
    priceFirst: 'від 6 000 грн',
    priceSecond: 'від 4 200 грн',
    unitFirst: "преміум",
    unitSecond: "оптимум",
    producer: "Євросем",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo5} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage5} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "evrosem-NS-6343",
    id: "22"
  },
  {
    title: "Насіння соняшнику Євросем ТОП 7+ СУМО НС 7749",
    priceFirst: 'від 5 700 грн',
    priceSecond: 'від 4 100 грн',
    unitFirst: "преміум",
    unitSecond: "оптимум",
    producer: "Євросем",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo5} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage5} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "evrosem-NS-7749",
    id: "23"
  },
  {
    title: "Насіння соняшнику Євросем АРКОНА СУМО (NS VLSP)",
    priceFirst: 'від 5 500 грн',
    priceSecond: 'від 4 000 грн',
    unitFirst: "преміум",
    unitSecond: "оптимум",
    producer: "Євросем",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo5} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage5} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "evrosem-NS-VLSP",
    id: "24"
  },
  {
    title: "Насіння соняшнику Євросем СТАРК 7+ СУМО (НС 8004)",
    priceFirst: 'від 6 000 грн',
    priceSecond: 'від 4 400 грн',
    unitFirst: "преміум",
    unitSecond: "оптимум",
    producer: "Євросем",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo5} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage5} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "evrosem-NS-8004",
    id: "25"
  },
  {
    title: "Насіння соняшнику Євросем СУМО 007 (НС 6059)",
    priceFirst: 'від 5 600 грн',
    priceSecond: 'від 3 900 грн',
    unitFirst: "преміум",
    unitSecond: "оптимум",
    producer: "Євросем",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo5} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage5} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "evrosem-NS-6059",
    id: "26"
  },
  {
    title: "Насіння соняшнику Євросем АВАЛОН 7+ (НС 6046)",
    priceFirst: 'від 5 500 грн',
    priceSecond: 'від 3 600 грн',
    unitFirst: "преміум",
    unitSecond: "оптимум",
    producer: "Євросем",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo5} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage5} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "evrosem-NS-6046",
    id: "27"
  },
  {
    title: "Насіння соняшнику Євросем АЯКС (НС DFSP)",
    priceFirst: 'від 5 000 грн',
    priceSecond: 'від 3 600 грн',
    unitFirst: "преміум",
    unitSecond: "оптимум",
    producer: "Євросем",
    InStock: true,
    imgLogo: <img className="itemPartner__image-logo" src={logo5} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage5} alt="goodsPage" />,
    isNew: true,
    link: <Link to="order"><Button /></Link>,
    inside: "evrosem-NS-DFSP",
    id: "28"
  },
  {
    title: "Насіння соняшнику HK Бріо (NK Brio)",
    priceFirst: 'від 6 500 грн',
    unitFirst: "1 п.о.",
    producer: "Syngenta",
    InStock: false,
    imgLogo: <img className="itemPartner__image-logo" src={logo1} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage} alt="goodsPage" />,
    isNew: false,
    link: <Link to="order"><Button /></Link>,
    inside: "brio",
    id: "1"
  },
  {
    title: "Насіння соняшнику HK Неома (NK Neoma)",
    priceFirst: 'від 6 700 грн',
    unitFirst: "1 п.о.",
    producer: "Syngenta",
    InStock: false,
    imgLogo: <img className="itemPartner__image-logo" src={logo1} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage} alt="goodsPage" />,
    isNew: false,
    link: <Link to="order"><Button /></Link>,
    inside: "neoma",
    id: "2"
  },
  {
    title: "Насіння соняшнику HK Конді (NK Kondi)",
    priceFirst: 'від 6 400 грн',
    unitFirst: "1 п.о.",
    producer: "Syngenta",
    InStock: false,
    imgLogo: <img className="itemPartner__image-logo" src={logo1} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage} alt="goodsPage" />,
    isNew: false,
    link: <Link to="order"><Button /></Link>,
    inside: "kondi",
    id: "3"
  },
  {
    title: "Насіння соняшнику Суміко HTS (Sumiko HTS)",
    priceFirst: 'від 5 000 грн',
    unitFirst: "1 п.о.",
    producer: "Syngenta",
    InStock: false,
    imgLogo: <img className="itemPartner__image-logo" src={logo1} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage} alt="goodsPage" />,
    isNew: false,
    link: <Link to="order"><Button /></Link>,
    inside: "sumiko",
    id: "4"
  },
  {
    title: "Насіння соняшнику MAC 87.A (MAS 87.A)",
    priceFirst: 'від 2 500 грн',
    unitFirst: "1 п.о.",
    producer: "MAS Seeds",
    InStock: false,
    imgLogo: <img className="itemPartner__image-logo" src={logo2} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage1} alt="goodsPage" />,
    isNew: false,
    link: <Link to="order"><Button /></Link>,
    inside: "mas87",
    id: "5"
  },
  {
    title: "Насіння соняшнику MAC 86.КП (MAS 86.CP)",
    priceFirst: 'від 2 500 грн',
    unitFirst: "1 п.о.",
    producer: "MAS Seeds",
    InStock: false,
    imgLogo: <img className="itemPartner__image-logo" src={logo2} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={goodsPage1} alt="goodsPage" />,
    isNew: false,
    link: <Link to="order"><Button /></Link>,
    inside: "mas86",
    id: "6"
  }
];
